export default __webpack_public_path__ + "static/media/card.b30b4ea7.svg";